import React, { useContext } from 'react';
import { AppStateContext } from '../../state/AppProvider';
import { ChatHistoryListItemGroups } from './ChatHistoryListItem';
import {ACTIVE_SESSION_MINUTES}  from '../../constants/config';
interface ChatHistoryListProps {}

export interface GroupedChatHistory {
    month: string;
    entries: Conversation[]
}

const groupByMonth = (entries: Conversation[]) => {
    const groups: GroupedChatHistory[] = [{ month: "Recent", entries: [] }];
    const currentDate = new Date();
  
    entries.forEach((entry) => {
        const entryDate = new Date(Date.parse(entry.createdAt))
        const minutesDifference = (currentDate.getTime() - entryDate.getTime()) / (1000 * 60 );
        const monthYear = entryDate.toLocaleString('default', { month: 'long', year: 'numeric' })
        const existingGroup = groups.find((group) => group.month === monthYear);

        if(minutesDifference <  ACTIVE_SESSION_MINUTES){
            entry.isRecent = true
            groups[0].entries.push(entry);
        }else if (existingGroup) {
            existingGroup.entries.push(entry);
        } else {
            groups.push({ month: monthYear, entries: [entry] });
        }
    });

    groups.sort((a, b) => {
        // Check if either group has no entries and handle it
        if (a.entries.length === 0 && b.entries.length === 0) {
            return 0; // No change in order
        } else if (a.entries.length === 0) {
            return 1; // Move 'a' to a higher index (bottom)
        } else if (b.entries.length === 0) {
            return -1; // Move 'b' to a higher index (bottom)
        }
        // console.log("a:", a.entries[0], "b:", b.entries[0])
        const dateA =new Date(Date.parse(a.entries[0].createdAt)) 
        const dateB = new Date(Date.parse(b.entries[0].createdAt)) 
        return dateB.getTime() - dateA.getTime();
    });

    groups.forEach((group) => {
        group.entries.sort((a, b) => {
            if(a && b){
                const dateA = new Date(Date.parse(a.createdAt));
                const dateB = new Date(Date.parse(b.createdAt));
                return dateB.getTime() - dateA.getTime();
            }
            else{
                return 0;
            }
        });
    });
  
    return groups;
};

const ChatHistoryList: React.FC<ChatHistoryListProps> = () => {
    const appStateContext = useContext(AppStateContext);
    const chatHistory = appStateContext?.state.chatHistory;

    React.useEffect(() => {}, [appStateContext?.state.chatHistory]);
    
    let groupedChatHistory;
    if(chatHistory && chatHistory.length > 0){
        // console.log("chatHistory", chatHistory)
        groupedChatHistory = groupByMonth(chatHistory);
    }else{
        return (
            <div>No recent session histories</div>
        );
    }
    
    return (
        <ChatHistoryListItemGroups groupedChatHistory={groupedChatHistory}/>
    );
};

export default ChatHistoryList;